const Blockly = require('blockly');
const dataAccessMethods = require('../../dataAccessMethods');
const mdcConfig = require('@sstdev/lib_metadata-config');
const arrayFromCommaSeparatedValues = require('../../helpers/arrayFromCommaSeparatedValues');
const convertToBoolean = require('../../helpers/convertToBoolean');
const setupAddCodeProperties = require('../../helpers/addCodeProperties');

const BaseMdcBlockGroup = require('./_BaseMdcBlockGroup');

const { config } = mdcConfig;

const TOOLTIPS = {
    ToUpperCase: 'Transforms the value to upper case',
    ToLowerCase: 'Transforms the value to lower case',
    ToNumber: 'Transforms the value to a number',
    ToBoolean: 'Transforms the value to a boolean. False Values are case insensitive',
    ToHexFromAscii: 'Transforms an Ascii value to hex',
    ToAsciiFromHex: 'Transforms a hex value to Ascii',
    DefaultToPreviousSelection: 'Uses the previous submitted value as the default for this field',
    TabAfterScan: 'IF the data for the field came from a scanned barcode, perform a tab after the scan',
    ActionAfterScan:
        'IF the data for the field came from a scanned barcode, perform an action. Basically a barcode-scan triggered action button.'
};

class Transform extends BaseMdcBlockGroup {
    /**
     * @param {{[key: string]: any}} code
     * @param {Blockly.Block} blocklyBlock
     * @param {string} hNodeType
     */
    addCodeGeneratorCustom(code, blocklyBlock, hNodeType) {
        const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);

        if (['ToUpperCase', 'ToLowerCase'].includes(hNodeType)) {
            addCodeProperties([{ key: 'transformInline', handler: convertToBoolean }]);
        }

        if (hNodeType === 'ToBoolean') {
            addCodeProperties([{ key: 'falseValues', handler: arrayFromCommaSeparatedValues }]);
        }

        if (hNodeType === 'DefaultToPreviousSelection') {
            // No custom code properties are needed for this marker transform.
        }

        if (['ActionAfterScan'].includes(hNodeType)) {
            addCodeProperties(['namespace', 'relation', 'forAction', 'subtype']);
        }
        if (['TabAfterScan', 'ActionAfterScan'].includes(hNodeType)) {
            addCodeProperties(['dataWedgeCharacter']);
        }

        return JSON.stringify(code);
    }

    /**
     * @param {*} color
     * @param {Blockly.Block} blocklyBlock
     * @param {string} hNodeType
     */
     
    addToBlocksCustom(color, blocklyBlock, hNodeType, mdcBlock, topInput) {
        if (TOOLTIPS[hNodeType]) {
            blocklyBlock.setTooltip(TOOLTIPS[hNodeType]);
        }

        if (['ToUpperCase', 'ToLowerCase'].includes(hNodeType)) {
            topInput
                .appendField('  Transform While Typing:')
                .appendField(new Blockly.FieldCheckbox(false), 'transformInline');
        }

        if (hNodeType === 'ToBoolean') {
            topInput
                .appendField('  False Values:')
                .appendField(new Blockly.FieldTextInput('false, 0, no,'), 'falseValues');
        }

        if (['TabAfterScan', 'ActionAfterScan'].includes(hNodeType)) {
            const fieldInput = new Blockly.FieldTextInput('30');
            fieldInput.setTooltip(
                'Character 30 is the ASCII code for the "record separator". This is the default character we use in DataWedge to indicate a scanned data record.'
            );
            topInput.appendField('  Data Wedge Identifying Character:').appendField(fieldInput, 'dataWedgeCharacter');
        }

        if (hNodeType === 'ActionAfterScan') {
            let workspace = blocklyBlock.workspace;
            let blockId = blocklyBlock.id;
            blocklyBlock.setInputsInline(false);
            const line2OfInput = blocklyBlock
                .appendDummyInput()
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('  Namespace:')
                .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace')
                .appendField('  Relation:')
                .appendField(
                    new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)),
                    'relation'
                );

            // Load possible actions and default action
            const actionsDropdown = new Blockly.FieldDropdown(config.scanActions);
            actionsDropdown.setValue('new');
            line2OfInput
                .appendField('  For Action:')
                .appendField(actionsDropdown, 'forAction')
                .appendField('  (optional) Subtype:')
                .appendField(new Blockly.FieldTextInput(), 'subtype');
        }
    }
}

module.exports = Transform;
